<template>
  <div>
    <div class="donation-title-2">Kies je bedrag:</div>
    <div class="grid-div">
      <template v-for="option in options" :key="option.id">
        <AmountTile @update="updateSelectedValue" :selectedValue="selectedValue" :value="option.value" :id="option.id" />
      </template>
      <div @click="activateCustomInput" :style="isActive ? isActiveStyle : ''"
        class="w-checkbox donation-grid-price-item">
        <span class="checkbox-label w-form-label">{{ value }}</span>
        <input v-model="customValue" @input="updateCustomValue" class="input" placeholder="...">

      </div>
    </div>
  </div>
</template>
<script>
import AmountTile from "@/elements/AmountTile.vue"
export default {
  components: {
    AmountTile,
  },
  props: ["initial_value"],
  created() {
    this.selectedValue = this.initial_value
  },
  data() {
    return {
      options: [
        { id: 5.0, value: "€5" },
        { id: 10.0, value: "€10" },
        { id: 15.0, value: "€15" },
        { id: 20.0, value: "€20" },
        { id: 30.0, value: "€30" },
        { id: 40.0, value: "€40" },
        { id: 50.0, value: "€50" },
        { id: 100.0, value: "€100" },
      ],
      value: "€",
      selectedValue: "",
      customValue: "",
      isActiveStyle: "background-color:#3898EC; color:white",
      isActive: false,
    }
  },
  methods: {
    updateSelectedValue(value) {
      this.$store.state.payment_info.amount = value.toFixed(2)
      this.selectedValue = value
      this.resetCustomInput()
    },
    updateCustomValue() {
      this.$store.state.payment_info.amount = parseFloat(this.customValue).toFixed(2)
      this.selectedValue = parseFloat(this.customValue)
      this.$emit('custom-value-updated', this.customValue)
      this.logCustomValue()
    },
    logCustomValue() {
      console.log(`Custom Value: ${this.customValue}`);
    },
    activateCustomInput() {
      this.isActive = !this.isActive;
      if (this.isActive) {
        this.updateCustomValue();
      } else {
        this.selectedValue = '';
      }
    },
    resetCustomInput() {
      this.customValue = '';
      this.isActive = false;
    },
  },
}
</script>

<style scoped>
.input {
  border: none;
  outline: none;
  background-color: transparent;
  padding: 0px;
  margin: 0px;
  font-weight: 600;
  max-width: 50%;
  display: flex;
  text-align: center;
}
</style>
